import { environment } from 'environments/environment';

export const DEFAULT_CLIENT = {
  id: environment.CLIENT,
  name: 'Gamelearn'
};

export const PUBLISH_DEFAULT = {
  active: false,
  mode: 'private',
  clientId: [],
  scope: null
};

export const OWNER_ITINERARY_OPTIONS = [
  { key: 'all', isActiveOption: () => true, value: 'itineraries.tabs.all' },
  {
    key: 'gamelearn',
    isActiveOption: () => true,
    value: 'itineraries.tabs.gamelearn'
  },
  {
    key: 'myItineraries',
    isActiveOption: (component) => component.client,
    value: 'itineraries.tabs.myItineraries'
  }
];

export const SCOPES = {
  itineraries: 'itineraries',
  clients: 'clients'
};

export const BUTTON_ACTIONS_ITINERARIES = [
  { key: 'changeAccess', value: 'actions.changeAccess', profile: 'courses.changeAccessMode' },
  { key: 'shouldSendDiploma', value: 'actions.shouldSendDiploma', profile: 'courses.shouldSendDiploma' }
];
